import { useMemo, useState } from "react";

import SelectFilter, {
  VisualState,
} from "~/components/dashboard/PageTable/filters/SelectFilter";
import selectFilterStyles from "~/components/dashboard/PageTable/filters/SelectFilter.module.scss";
import { getItemClass } from "~/components/dashboard/PageTable/statusConstants";

const SOURCE_OPTIONS = [
  { value: "all", label: "Source: All" },
  { value: "divider", label: "", isDivider: true },
  { value: "auto", label: "Auto" },
  { value: "manual", label: "Manual" },
];

const getSourceFilterTitle = (
  sourceFilter: "auto" | "manual" | undefined,
): string => {
  if (!sourceFilter) return "Source: All";

  return `Source: ${sourceFilter === "auto" ? "Auto" : "Manual"}`;
};

interface SourceFilterProps {
  sourceFilter: "auto" | "manual" | undefined;
  onSourceFilterChange: (source: "auto" | "manual" | undefined) => void;
}

const SourceFilter = ({
  sourceFilter,
  onSourceFilterChange,
}: SourceFilterProps) => {
  const [hoveredValue, setHoveredValue] = useState<string | null>(null);

  const isAllSelected = !sourceFilter;

  const getVisualState = (value: string): VisualState => {
    if (value === "all") {
      return isAllSelected ? "checked" : "none";
    }

    if (hoveredValue === value) {
      return "checked";
    }

    if (isAllSelected) {
      return "crossed";
    }

    return value === sourceFilter ? "checked" : "none";
  };

  const handleSelect = (value: string) => {
    if (value === "all") {
      onSourceFilterChange(undefined);

      return;
    }

    if (value === sourceFilter) {
      onSourceFilterChange(undefined);

      return;
    }

    onSourceFilterChange(value as "auto" | "manual");
  };

  const itemsWithClass = useMemo(
    () =>
      SOURCE_OPTIONS.map((item) =>
        getItemClass({
          item,
          isPresetSelected: isAllSelected,
          isRealSelected: !isAllSelected,
          isPresetItem: item.value === "all",
          styles: selectFilterStyles,
        }),
      ),
    [isAllSelected],
  );

  return (
    <SelectFilter
      items={itemsWithClass}
      filterTitle={getSourceFilterTitle(sourceFilter)}
      onSelect={handleSelect}
      getVisualState={getVisualState}
      setHoveredValue={setHoveredValue}
      dropdownAlign="right"
    />
  );
};

export default SourceFilter;
